import { Button, Col, Input, Modal, Row, Descriptions, Image } from "antd";
import React, { useState } from "react";
import { INPUT_TYPE, MODE_SCREEN, lang } from "../../constants/common.const";
import FormInput from "../../component/FormInput";
import { useMediaQuery } from "react-responsive";
import FacilityImage from "./facilityImage";
import { formatDecimal } from "../../utils/helper";

function BasicInformation({
  listData = [],
  mode,
  handlechangeInput = () => {},
  activeTabKey,
  imageUrl,
  setImageUrl,
}) {
  const isPC = useMediaQuery({
    query: "(min-width: 1024px)",
  });
  const [openModalTitle, setOpenModalTitle] = useState(false);
  const [currentItem, setCurrentItem] = useState("");

  const changeInput = (e, item) => {
    const value = e.target ? e.target.value : e;
    handlechangeInput(
      item.key,
      value,
      item.rule,
      item.type,
      item.isFormatNumber
    );
  };

  const renderInput = (item) => {
    if (item.type === INPUT_TYPE.CUSTOM) {
      return item.component;
    }
    if (item.type === INPUT_TYPE.LABEL) {
      return item.value.value;
    }
    if (mode === MODE_SCREEN.EDIT) {
      return (
        <FormInput
          onChange={(e) => {
            changeInput(e, item);
            if (item.customChange) {
              item.customChange(e, item);
            }
          }}
          valueObject={item.value}
          disabled={item.disabled}
          refer={item.refer}
          haveEmptyOption={item.haveEmptyOption}
          onBlur={(e) => {
            if (item.type === INPUT_TYPE.INPUT && item.isDecimal && item.key !== 'waterLevelAtDischargeDestination') {
              const value = e.target.value;
              let finalValue = item.isFormatNumber
                ? String(value).replace(/,/g, "")
                : value;
              finalValue = formatDecimal(Number(finalValue), item.isDecimal);
              changeInput({ target: { value: finalValue } }, item);
            }
          }}
          {...item}
        />
      );
    }
    if (item.type === INPUT_TYPE.SWITCH) {
      return item.value.value === true ? lang.YES : lang.NO;
    }
    return item.type === INPUT_TYPE.DATE
      ? item.value.valueString
      : item.value.label || item.value.valueShow || item.value.value;
  };

  const changeTitle = (item) => {
    if (!item.editTitle || mode === MODE_SCREEN.VIEW) {
      return;
    }
    setCurrentItem(item);
    setOpenModalTitle(true);
  };

  const renderDescriptions = (list) => {
    return (
      <Row>
        <Col span={20}>
          <Descriptions
            className="customEquipmentDes"
            size="small"
            column={1}
            bordered
          >
            {list.slice(0, 5).map((item, index) => (
              <Descriptions.Item
                style={{ width: item.span == 1 ? "30%" : "80%" }}
                key={index}
                labelStyle={{
                  width: "8%",
                }}
                label={
                  <div
                    onClick={() => changeTitle(item)}
                    style={{
                      cursor: item.editTitle && "pointer",
                      color: item.required ? "red" : undefined,
                    }}
                    className="labelInputEquipment bold"
                  >
                    {item.title}
                  </div>
                }
                span={item.span || 1}
              >
                {renderInput(item)}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </Col>
        <Col span={4} style={{ textAlign: "right" }}>
          <FacilityImage
            setImage={setImageUrl}
            mode={mode}
            imageUrl={imageUrl}
          />
          {/* <Image
            style={{
              height: "190px",
            }}
            src={
              "/img/default.png"
            }
          /> */}
        </Col>
        <Col span={24}>
          <Descriptions
            className="customEquipmentDes"
            size="small"
            column={1}
            bordered
          >
            {list.slice(6, 23).map((item, index) => (
              <Descriptions.Item
                style={{ width: item.span == 1 ? "30%" : "80%" }}
                key={index}
                labelStyle={{
                  width: "6.35%",
                }}
                label={
                  <div
                    onClick={() => changeTitle(item)}
                    style={{
                      cursor: item.editTitle && "pointer",
                      color: item.required ? "red" : undefined,
                    }}
                    className="labelInputEquipment bold"
                  >
                    {item.title}
                    {mode !== MODE_SCREEN.VIEW &&
                      item.required &&
                      activeTabKey === false && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </div>
                }
                span={item.span || 1}
              >
                {renderInput(item)}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </Col>
      </Row>
    );
  };

  return <div>{renderDescriptions(listData)}</div>;
}

export default BasicInformation;
